module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":{"employer":"Skilled Worker visa service was started for the candidate. If you want to amend any data, please do it in the Skilled Worker visa service.","candidate":"Skilled Worker visa service was started. If you want to amend any data, please do it in the Skilled Worker visa service."}}}')
  delete Component.options._Ctor
}
